import { inject, onMounted } from "vue";
import dayjs from "dayjs";

export const formatNumber = (input = 0, divider = 100) => {
  return divider != 0
    ? (+input / +divider).toLocaleString("en", {
        useGrouping: true,
        minimumFractionDigits: 2,
      })
    : "0";
};

export const translate = (message: string) => {
  const t: any = inject("$t");
  return t.global.t(message);
};

export const camalize = (str: string) => {
  return str
    .toLowerCase()
    .replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase());
};

export const timeDiff = (checkDate: any) => {
  const now = dayjs(new Date());
  const check = dayjs(checkDate);
  return now.diff(check, "minutes");
};
